"use client";

import { useRef } from "react";
import { ArrowDown, ArrowRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP);
const partnerMarks = [{
  name: "MIAMI DADE"
}, {
  name: "HOMESTEAD"
}, {
  name: "CORAL GABLES"
}, {
  name: "WEST KENDALL"
}];
const headlineWordsBefore = ["Mobile", "care", "for", "your", "finest"];
const headlineWordsAfter = ["assets."];
export default function Detailing() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".sk-eyebrow", {
        y: 12
      });
      gsap.set(".sk-word", {
        y: 40
      });
      gsap.set(".sk-italic", {
        y: 40,
        filter: "blur(6px)"
      });
      gsap.set(".sk-lead", {
        y: 20
      });
      gsap.set(".sk-cta-wrap", {
        y: 20
      });
      gsap.set(".sk-mark", {
        y: 12
      });
      gsap.set(".sk-scroll-cue", {
        y: 12
      });
      const ease = "cubic-bezier(0.22, 1, 0.36, 1)";
      const tl = gsap.timeline({
        defaults: {
          ease
        }
      });
      tl.to(".sk-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.9
      }, 0.1).to(".sk-word", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.09
      }, 0.35).to(".sk-italic", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 1.1
      }, "-=0.5").to(".sk-lead", {
        opacity: 1,
        y: 0,
        duration: 0.9
      }, "-=0.3").to(".sk-cta-wrap", {
        opacity: 1,
        y: 0,
        duration: 0.9
      }, "-=0.5").to(".sk-mark", {
        opacity: 0.55,
        y: 0,
        duration: 0.8,
        stagger: 0.06
      }, "-=0.6").to(".sk-scroll-cue", {
        opacity: 1,
        y: 0,
        duration: 0.8
      }, "-=0.6");
      gsap.to(".sk-cta-glow", {
        opacity: 0.18,
        duration: 1.6,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: 2.5
      });
      gsap.to(".sk-aura", {
        x: 40,
        y: 24,
        duration: 20,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".sk-eyebrow", ".sk-word", ".sk-italic", ".sk-lead", ".sk-cta-wrap", ".sk-scroll-cue"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
      gsap.set(".sk-mark", {
        opacity: 0.55,
        y: 0
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="28781" id="the-pinnacle-of-mobile-detailing-el-pináculo-del-detallado-móvil" ref={container} className="relative min-h-screen w-full overflow-hidden bg-background text-foreground" style={{
    minHeight: "max(100vh, 720px)"
  }}>
      <div className="absolute inset-0 h-screen md:h-full">
        <video src="https://valeroelitedetailingmiami.com/wp-content/uploads/2026/07/486B3185-AEE8-4432-8CC1-D73BCC421918.mov" muted loop playsInline autoPlay preload="metadata" className="h-full w-full object-cover" />
      </div>

      <div className="pointer-events-none absolute inset-0" style={{
      background: "rgba(0, 0, 0, 0.4)"
    }} aria-hidden="true" />

      <div className="sk-aura pointer-events-none absolute -left-40 bottom-24 h-[600px] w-[600px] rounded-lg" style={{
      background: "radial-gradient(closest-side, hsl(41 62% 62% / 0.14), transparent 70%)"
    }} aria-hidden="true" />

      <div className="relative z-10 flex min-h-screen w-full flex-col" style={{
      minHeight: "max(100vh, 720px)"
    }}>
        <div className="flex-1" />

        <div style={{
        paddingLeft: "clamp(24px, 5vw, 88px)",
        paddingRight: "clamp(24px, 5vw, 88px)",
        paddingBottom: "clamp(160px, 22vh, 240px)"
      }}>
          <div className="max-w-5xl">
            

            <h1 className="font-serif" style={{
            color: "hsl(38 32% 92%)",
            fontWeight: 300,
            fontSize: "clamp(3.25rem, 8.4vw, 8.5rem)",
            lineHeight: 0.98,
            letterSpacing: "-0.02em",
            margin: 0
          }}>Premium Mobile Detailing, Delivered to You.<br /></h1>

            <p className="sk-lead font-default" style={{
            opacity: 0,
            maxWidth: "480px",
            marginTop: "32px",
            fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
            fontWeight: 350,
            lineHeight: 1.65,
            color: "hsl(38 14% 68%)"
          }}>Professional detailing at your home or office throughout Miami</p>

            <div className="sk-cta-wrap relative flex flex-wrap gap-4" style={{
            opacity: 0,
            marginTop: "40px"
          }}>
              <Button asChild className="group relative rounded-lg font-default" style={{
              backgroundColor: "transparent",
              border: "1px solid hsl(41 62% 62% / 0.55)",
              color: "hsl(38 32% 92%)",
              padding: "18px 32px",
              height: "auto",
              fontSize: "0.9375rem",
              fontWeight: 500,
              letterSpacing: "0.04em"
            }}>
                <Link to="https://wa.me/17867784394">
                  <span>Book Your Service</span>
                  <ArrowRight className="transition-transform duration-300 ease-out group-hover:translate-x-1" style={{
                  color: "hsl(41 62% 62%)"
                }} strokeWidth={1.5} />
                </Link>
              </Button>

              <Button asChild className="group relative rounded-lg font-default" style={{
              backgroundColor: "transparent",
              border: "1px solid hsl(41 62% 62% / 0.55)",
              color: "hsl(38 32% 92%)",
              padding: "18px 32px",
              height: "auto",
              fontSize: "0.9375rem",
              fontWeight: 500,
              letterSpacing: "0.04em"
            }}>
                <Link to="/ServicesPage">
                  <span>VIEW PACKAGES</span>
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="absolute left-0 right-0" style={{
        bottom: "40px",
        paddingLeft: "clamp(24px, 5vw, 88px)",
        paddingRight: "clamp(24px, 5vw, 88px)"
      }}>
          <div className="flex flex-wrap items-center justify-center gap-x-16 gap-y-4 md:gap-x-24">
            {partnerMarks.map((mark, i) => <span key={i} data-index={i} className="sk-mark font-default uppercase" style={{
            opacity: 0,
            color: "hsl(38 14% 68%)",
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.24em",
            lineHeight: "20px",
            whiteSpace: "nowrap"
          }}>
                {mark.name}
              </span>)}
          </div>
        </div>

        
      </div>
    </section>;
}